export function numberWithCommas(x: number, decimals?: boolean) {
  if (decimals)
    return x
      .toFixed(2)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}
